import { render, staticRenderFns } from "./signMethod.vue?vue&type=template&id=e267b6d4&scoped=true&"
import script from "./signMethod.vue?vue&type=script&lang=js&"
export * from "./signMethod.vue?vue&type=script&lang=js&"
import style0 from "./signMethod.vue?vue&type=style&index=0&id=e267b6d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e267b6d4",
  null
  
)

export default component.exports